export const languageSwitch = {
  name: 'language-switch',

  mounted(el) {
    const button = el.querySelector('.js-current-language');
    const siteMenu = document.querySelector('.js-site-menu');

    button.addEventListener('click', () => {
      el.classList.toggle('open');

      if (siteMenu.classList.contains('current-language-open')) {
        siteMenu.classList.remove('current-language-open');
      } else {
        siteMenu.classList.add('current-language-open');
      }
    });

    siteMenu.addEventListener('menustatechange', () => {
      el.classList.remove('open');
      siteMenu.classList.remove('current-language-open');
    });
  },
};
